import { useEffect, useState } from 'react';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useNavigate, useParams } from 'react-router-dom';
import categoryApi from '../../../../api/categories';
import LoadingContent from '../../../../components/LoadingContent';
import { HobbyForm, HobbyFormError } from '../AddHobby';
import { ISkill } from '@wot/typings';
import { Button } from '@wot/components';
import { toast } from 'react-toastify';

interface Props {
  cat: ISkill;
}

export default function EditSkill({ cat }: Props) {
  const [category, setCategory] = useState<ISkill>();
  const { _id } = useParams();
  const [errors, setErrors] = useState<HobbyFormError>();
  const navigate = useNavigate();

  useEffect(() => {
    if (_id) {
      setCategory(cat);
    }
  }, [_id]);

  if (!category) {
    return <LoadingContent />;
  }

  const updateCategory = async () => {
    if (_id) {
      if (
        !category ||
        !category.name ||
        (!category.types?.length && category.levels?.length === 0) ||
        (category.types &&
          category.types.length > 0 &&
          category.types.some((type) => !type.name || type.levels.length === 0))
      ) {
        toast.error('Please fill out all the required fields');
        return;
      }
      const categories = await categoryApi.getCategories("skill");
      const temp = categories.filter((c) => c._id !== _id && c.category.name === category.name);
      if (temp.length > 0) {
        toast.error(`${category.name} skill already exists.`);
        return;
      }
      categoryApi
        .updateCategory({
          _id: _id,
          data: {
            category
          }
        })
        .then(() => {
          toast.success('Skill Updated');
          navigate(-1);
        })
        .catch(() => {
          toast.error('Something went wrong.');
        });
    }
  };

  return (
    <div className="w-full grow flex flex-col gap-7 p-4">
      <div className="w-full flex items-center justify-between">
        <div className="w-full flex items-center gap-4">
          <IoMdArrowRoundBack className="w-5 cursor-pointer" onClick={() => navigate(-1)} />
          <h1 className="text-xl font-semibold">Skill: {category.name}</h1>
        </div>
        <div className="max-w-xs">
          <Button
            text="Update"
            onClick={() => {
              if (
                !category.name ||
                (category.types?.length === 0 && !category.levels?.length) ||
                (category.levels?.length === 0 && !category.types?.length)
              ) {
                setErrors({
                  name: !category.name,
                  levels: category.types?.length === 0 && !category.levels?.length,
                  types: category.levels?.length === 0 && !category.types?.length
                });
                return;
              }
              setErrors(undefined);
              updateCategory();
            }}
          />
        </div>
      </div>

      <HobbyForm
        name={category.name}
        setName={(value) => setCategory({ ...category, name: value })}
        levelsList={category.levels || []}
        setLevelsList={(list) => setCategory({ ...category, levels: list })}
        types={category.types!}
        setTypes={(types) => setCategory({ ...category, types: types })}
        errors={errors}
      />
    </div>
  );
}
